import { User } from '../constants'

export const hasToken = () => !!getToken()
export const getToken = () => localStorage.getItem(User.AUTH_TOKEN)
